module.exports = __webpack_public_path__ + "static/media/credit-card.b62b32e7.svg";